export const splitArrayIntoChunks = <T>(inputArr: T[], itemsInArr: number): T[][] => {
  if (!inputArr.length || itemsInArr <= 0) {
    return [];
  }

  const result: T[][] = [];
  const remainder = inputArr.length % itemsInArr;
  const firstChunkSize = remainder || itemsInArr;

  result.push(inputArr.slice(0, firstChunkSize));

  for (let i = firstChunkSize; i < inputArr.length; i += itemsInArr) {
    result.push(inputArr.slice(i, i + itemsInArr));
  }

  return result;
};
